import { message, type Payloads } from "utilities/message/message";

export async function sendMessage<T = any, P = any>(
  type: keyof Payloads,
  payload: P,
): Promise<T> {
  const res = await message(type, payload);
  return res as unknown as T;
}
